import React, {Component} from 'react';
import PotentialBillingIncrease from "../components/tables/potentialBillingIncrease";
import PotentialBillingIncreaseGraph from "../charts/potentialBillingIncreaseGraph"

import * as dataService from "../service/data-info-chart/requestsUtil"
import {INCREASED_VALUE_ACCOUNTS, WHITOUT_INFORMATION} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";
var Loader = require('react-loader');

class PotentialBillingIncreaseComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {data: [], loaded: false}
  }

  componentDidMount() {
    dataService.getFetch(INCREASED_VALUE_ACCOUNTS + cbu.checkBusinessUnit(this.props.bu))
      .then((json) => {
        this.setState({data: json, loaded: true})
      });
  }

  render() {
    if (this.state.data.length > 0) {
      return (
        <Loader loaded={this.state.loaded}>
          <PotentialBillingIncreaseGraph data={this.state.data} loaded={this.state.loaded}/>
        </Loader>
      );
    } else {
      return (<Loader loaded={this.state.loaded}><h2 className="without-avilable-information">{WHITOUT_INFORMATION}</h2></Loader>);
    }


  }
}

export default PotentialBillingIncreaseComponent;




// WEBPACK FOOTER //
// ./src/components/potentialBillingIncreaseComponent.js